import { useEffect, useState } from 'react';
import { useMediaQuery } from '@hopskipdrive/react-components';
import { variables } from '@rideiq/shared/components/variables';

export const useInnerDimensions = () => {
  const isMobileOrTablet = useMediaQuery({ maxWidth: variables.breakpoints.desktop - 1 });
  const defaultHeightOffset = isMobileOrTablet ? variables.mobileSidebarHeight : 0;
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight - defaultHeightOffset,
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setDimensions({
        height: window.innerHeight - defaultHeightOffset,
        width: window.innerWidth,
      });
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [defaultHeightOffset]);

  return { dimensions };
};
